<template>
    <div>
      <div class="dd-action-bar" v-if="parseInt(polygonVectorLayersLength) > 0">
        <b-button
            :disabled="polygonsSelected.length < 1"
            class="dd-action-btn dd-action-btn--primary"
            @click="initStatsModal"
            id="statsBtn"
            title="Generate Statistics"
        >
            <fa :icon="['fa', 'chart-bar']" class="dd-action-btn__icon"></fa>
            <span>Statistics</span>
        </b-button>
        <b-button
            class="dd-action-btn dd-action-btn--ghost"
            title="Clear Polygon"
            @click="clearPolygon"
        >
            <fa :icon="['fa', 'eraser']" class="dd-action-btn__icon"></fa>
            <span>Clear</span>
        </b-button>
      </div>
      <DDT_StatisticsWindow 
        :polygons="polygons"
        :selectedExtent="selectedExtent" 
        :user="user"
        @removePolygons="$emit('removePolygons')"
        @notification="$emit('notification', $event)"
        @admin-notification="$emit('admin-notification', $event)"
      ></DDT_StatisticsWindow>
    </div>
</template>
<style src="./Data_Tools.css" scoped></style>

<style>
/* ── Floating contextual action bar (bottom-center) ── */
.dd-action-bar {
    position: fixed;
    bottom: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4375rem;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 999px;
    box-shadow: 0 8px 28px rgba(6, 60, 109, 0.28);
    z-index: 1000;
}
.dd-action-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    height: 2.5rem;
    padding: 0 1.25rem;
    border: none !important;
    border-radius: 999px;
    font-size: 0.8125rem;
    font-weight: 600;
    letter-spacing: 0.01em;
    box-shadow: none !important;
    transition: background 0.15s ease, color 0.15s ease, transform 0.1s ease;
}
.dd-action-btn:active {
    transform: translateY(1px);
}
.dd-action-btn__icon {
    font-size: 0.9375rem;
}
.dd-action-btn--primary,
.dd-action-btn--primary:focus {
    background: #063c6d !important;
    color: #ffffff !important;
}
.dd-action-btn--primary:hover:not(.disabled):not(:disabled) {
    background: #0a5ca3 !important;
    color: #ffffff !important;
}
.dd-action-btn--primary.disabled,
.dd-action-btn--primary:disabled {
    background: rgba(6, 60, 109, 0.25) !important;
    color: rgba(255, 255, 255, 0.85) !important;
    cursor: not-allowed;
}
.dd-action-btn--ghost,
.dd-action-btn--ghost:focus {
    background: transparent !important;
    color: #063c6d !important;
}
.dd-action-btn--ghost:hover {
    background: rgba(6, 60, 109, 0.09) !important;
    color: #063c6d !important;
}

.sample-btn.disabled {
    border: 1px black solid !important;
}
.sample-btn {
    height: 2.5rem;
    width: 15.625rem;
    border: 1px black solid;
    font-size: 0.9rem;
    max-width: 15.625rem;
    margin-bottom: 0.3125rem;
}
.clear-btn {
    height: 3.125rem;
    width: 5rem;
    border: 1px white solid;
    font-size: 1rem;
    max-width: 3.75rem;
    background-color: #007BFF;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    align-items: center;
    font-size: large;
}
.clear-button-container {
    width: 2.8125rem;
    height: 2.1875rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    justify-self: right;
    border: 1px black solid;
}
.data-size {
  font-size: 0.9375rem !important;
  font-weight: 700;
  /* color: #007bff !important; */
}
</style>

<script>
import WKT from 'ol/format/WKT';
// import DT_InformationModal from './DT_InformationModal.vue';
import DDT_StatisticsWindow from './DDT_StatisticsWindow.vue';
export default {
    name: 'Measurement',
    props: ['polygonsSelected','polygonVectorLayersLength', 'user', 'selectedExtent'],
    components: {
        DDT_StatisticsWindow
    },
    data() {
        return {
            polygons: [],
            measurePolygonsSelected: null,
        }
    },
    methods: {
        async initStatsModal() {
            this.polygons = await this.formulatePolygons();

            this.$nextTick(() => {
                this.$bvModal.show('DDTStatsModal');
            })
        },
        async formulatePolygons() {
            const format = new WKT();
            this.polygons = [];
            let polyWKTS = [];

            for (const polygon of this.polygonsSelected) {
                const polygonWkt = format.writeGeometry(polygon.getGeometry(), {
                    dataProjection: 'EPSG:4326',
                    featureProjection: 'EPSG:3857'
                });

                polyWKTS.push(polygonWkt);
            }

            return polyWKTS;
        },
        clearPolygon(){
            this.$emit('clearPolygon');
        }
    }
}
</script>